import { itemsPerPage } from 'core/constants/pagination.constants';
import { INavigationState } from './types';

export const SLICE_NAMESPACE = 'navigation';

export const initialState: INavigationState = {
  navigationList: {
    trees: [],
    loading: { default: false, status: false },
    pagination: {
      totalPages: 0,
      currentPage: 1,
      itemsPerPage,
      totalItems: 0,
    },
    query: '',
  },
  form: {
    errors: {},
    success: false,
    loading: false,
  },
  options: {
    priceGroups: {
      list: [],
      loading: false,
    },
    categories: {
      list: [],
      loading: false,
    },
  },
};
